import { useState } from "react";
import { testimonials } from "@/mocks/homeData";

export default function TestimonialSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="px-4 md:px-6 lg:px-10 py-14 md:py-20 lg:py-24">
      <div className="max-w-7xl mx-auto">
        <div className="bg-foreground-950 rounded-3xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-0">
            {/* Left: Image Area */}
            <div className="lg:col-span-2 relative">
              <div className="h-64 lg:h-full lg:min-h-[420px] relative overflow-hidden">
                <img
                  src="https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/cbcb6d78-1c0c-4217-b9ab-b08bec360a61_compressed_a3053f40-8a77-48f2-b271-760c5b8f1e5f.webp"
                  alt="Green EXIT sign above doorway with illuminated stairwell in Singapore building"
                  title="Ezzogenics emergency exit installation project"
                  className="w-full h-full object-cover lg:object-top"
                  width="600"
                  height="800"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-foreground-950/20 lg:hidden"></div>
              </div>
              {/* Decorative element */}
              <div className="hidden lg:block absolute -top-4 -left-4 w-24 h-24 border border-accent-500/30 rounded-full"></div>
            </div>

            {/* Right: Quote Area */}
            <div className="lg:col-span-3 p-8 md:p-10 lg:p-12 flex flex-col justify-center">
              {/* Quote Icon */}
              <div className="w-12 h-12 rounded-full bg-primary-500/20 flex items-center justify-center mb-6">
                <i className="ri-double-quotes-l text-primary-400 text-2xl"></i>
              </div>

              {/* Quote Text */}
              <blockquote className="text-background-50 text-lg md:text-xl lg:text-2xl font-medium leading-relaxed mb-8">
                &ldquo;{testimonials[activeIndex].quote}&rdquo;
              </blockquote>

              {/* Author */}
              <div className="mb-8">
                <p className="text-background-50 font-semibold text-base">
                  {testimonials[activeIndex].author}
                </p>
                <p className="text-background-400 text-sm">
                  {testimonials[activeIndex].role}
                </p>
              </div>

              {/* Dots */}
              <div className="flex items-center gap-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveIndex(index)}
                    className={`w-2.5 h-2.5 rounded-full transition-all ${
                      index === activeIndex
                        ? "bg-primary-500 w-8"
                        : "bg-background-600 hover:bg-background-500"
                    }`}
                    aria-label={`View testimonial ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}